export enum ThemeOptionEnum {
  light = 'light',
  dark = 'dark',
}
